import React, { useState } from 'react';

const LinkModal = ({ isOpen, onClose, onConfirm }) => {
    const [url, setUrl] = useState('https://');
    if (!isOpen) return null;

    const handleConfirm = () => {
        if (url && url !== 'https://') {
            onConfirm(url);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white rounded-lg p-6 m-4 max-w-sm w-full shadow-xl">
                <h3 className="text-lg font-medium text-gray-900">Ajouter un lien</h3>
                <div className="mt-4">
                    <label htmlFor="link-url" className="block text-sm font-medium text-gray-700">URL du lien</label>
                    <input
                        type="text"
                        id="link-url"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                </div>
                <div className="mt-5 sm:flex sm:flex-row-reverse">
                    <button onClick={handleConfirm} type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm">Ajouter</button>
                    <button type="button" onClick={onClose} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm">Annuler</button>
                </div>
            </div>
        </div>
    );
};

export default LinkModal;